import { useLocation, useRouter } from "@tanstack/react-router";

import type { SingleToggleGroupProps } from "./common";
import { generateValueProps, translateLanguageCode } from "./common";

import { SUPPORTED_LANGUAGES, useTranslation2 } from "~/shared/i18n";
import { ToggleGroup, ToggleGroupItem } from "~/shared/ui/toggle-group";

type Props = Omit<SingleToggleGroupProps, "type" | "value" | "onValueChange">;

function Toggle({ ...props }: Props) {
  const {
    translation: { t, i18n },
  } = useTranslation2();
  const router = useRouter();
  const location = useLocation();

  return (
    <ToggleGroup type="single" {...generateValueProps(i18n, router, location)} {...props}>
      {(Object.keys(SUPPORTED_LANGUAGES) as (keyof typeof SUPPORTED_LANGUAGES)[]).map((value) => (
        <ToggleGroupItem key={value} value={value}>
          {translateLanguageCode(t, value)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}

export { Toggle };
